module.exports = __webpack_public_path__ + "img/20191202173549661.156bc818.jpg";